// Kept separate from QueryClient and API modules so the offline cache can use
// the same identity without introducing an auth/API import cycle.
let scope = JSON.stringify([null, null]);
const SCOPE_STORAGE_KEY = "authenticated-cache-scope";

export function authenticatedCacheScope(): string {
  return scope;
}

export function savedAuthenticatedCacheScope(): string | null {
  try { return sessionStorage.getItem(SCOPE_STORAGE_KEY); }
  catch { return null; }
}

export function setAuthenticatedCacheScope(userId: string | null, workspaceId: string | null): void {
  scope = JSON.stringify([userId, workspaceId]);
  try { sessionStorage.setItem(SCOPE_STORAGE_KEY, scope); } catch {}
}
